import React from 'react';
import { Area } from '@ant-design/plots';
import { useEffect } from 'react';
import { useState } from 'react';
import NoData from '../../custom-components/NoData'


export const GrtLineChart = (props) => {
  const {
    data,
    isSmooth,
    isShowSlider,
    isMedian,
    isLadder,
    color,
    fillColor,
    isShowPoint,
    pointSize,
    padding,
    yAxisText,
    yAxisFontSize,
    yAxisColor,
    yAxisTitleOffset,
    yPosition,
    yTitlePosition,
    xAxisText,
    xAxisFontSize,
    xAxisColor,
    xAxisTitleOffset,
    xPosition,
    xTitlePosition,
    isShowTooltip,
    tooltipTypeLabel,
    tooltipValueLabel,
    setGradient,

    setXAxisLabel,
    setYAxisLabel,
    xLabelRotateNum,
    xLabelColor,
    xLabelOpacity,
    yLabelRotateNum,
    yLabelColor,
    yLabelOpacity,
    xField,
    yField,
    xLabelOffsetY,
    yLabelOffsetX,
    yAxisType,
    yAxisLabelMin,
    yAxisLabelMax,
    yAxisLabelTickCount,
    isShowTooltipTitle,
    tooltipTitle,
    tickCount,
    tickInterval
  } = props

  const defalutConfig = {
    data,
    smooth: isSmooth,
    slider: isShowSlider ? {
      start: 0,
      end: 0.2,
    } : null,
    padding,
    xField: xField,
    yField: yField,
    color,
    line: {
      color
    },
    annotations: isMedian ? [
      // 低于中位数颜色变化
      {
        type: 'regionFilter',
        start: ['min', 'median'],
        end: ['max', '0'],
        color: '#ccc',
      },
      {
        type: 'text',
        position: ['min', 'median'],
        content: '中位数',
        offsetY: -4,
        style: {
          textBaseline: 'bottom',
        },
      },
      {
        type: 'line',
        start: ['min', 'median'],
        end: ['max', 'median'],
        style: {
          stroke: '#F4664A',
          lineDash: [2, 2],
        },
      },
    ] : null,
    stepType: isLadder ? 'vh' : null,
    yAxis: {

      nice: true,
      type: yAxisType ? 'log' : 'linear',
      position: yPosition,
      title: {
        text: yAxisText,
        autoRotate: true,
        offset: yAxisTitleOffset,
        position: yTitlePosition,
        style: {
          fontSize: yAxisFontSize,
          fill: yAxisColor
        }
      },
      label: {
        formatter: setYAxisLabel,
        rotate: yLabelRotateNum,
        offsetX: yLabelOffsetX,
        autoHide: true,
        autoRotate: false,
        style: {
          fill: yLabelColor,
          opacity: yLabelOpacity ? yLabelOpacity / 1 : 1
        },

      },
      min: yAxisLabelMin,
      max: yAxisLabelMax,
      tickCount: yAxisLabelTickCount,
      tickMethod: 'd3-linear'

    },

    xAxis: {
      tickCount,
      tickInterval,
      range: [0.03, 0.97],
      position: xPosition,
      title: {
        text: xAxisText,
        autoRotate: false,
        offset: xAxisTitleOffset,
        position: xTitlePosition,
        style: {
          fontSize: xAxisFontSize,
          fill: xAxisColor
        }
      },
      label: {
        formatter: setXAxisLabel,
        rotate: xLabelRotateNum,
        autoHide: true,
        autoRotate: false,
        offsetY: xLabelOffsetY,
        style: {
          fill: xLabelColor,
          opacity: xLabelOpacity ? xLabelOpacity / 1 : 1
        }
      }
    },

    areaStyle: {
      fill: fillColor
    },
    tooltip: isShowTooltip ? {
      fields: [xField, yField],
      showTitle: isShowTooltipTitle,
      title: tooltipTitle
    } : isShowTooltip,
    meta: {
      [xField]: {
        alias: tooltipTypeLabel
      },
      [yField]: {
        alias: tooltipValueLabel
      }
    },
    areaStyle: setGradient,
    point: isShowPoint ? {
      size: pointSize,
      shape: 'circular',
      style: {
        fill: '#5B8FF9'
      },
    } : null
  };


  // const [config, setConfig] = useState(defalutConfig);

  // // 整数（由于antv没提供整数功能是，如果y轴有大于3的会默认整数，如果是一或者二即使设置了minTickInterval也不生效，所以判断要显示几个横轴）
  // const setConfigYAxis = () => {
  //   if (data && data.length > 0) {
  //     let countFlag = 0;
  //     data.forEach(v => {
  //       if (v[yField] >= 3) {
  //         countFlag = 3
  //       } else if (v[yField] === 2) {
  //         countFlag = 2
  //       } else {
  //         countFlag = 1
  //       }
  //     })
  //     if (countFlag === 3) {
  //       defalutConfig.yAxis.minTickInterval = 1
  //     } else if (countFlag === 2) {
  //       defalutConfig.yAxis.tickCount = 2;
  //       defalutConfig.yAxis.tickMethod = 'd3-linear'
  //     } else {
  //       defalutConfig.yAxis.tickCount = 1;
  //       defalutConfig.yAxis.tickMethod = 'd3-linear'
  //     }
  //     setConfig(defalutConfig)
  //   }
  // }

  // useEffect(() => {
  //   if (yAxisInteger) {
  //     setConfigYAxis()
  //   }
  // }, [data])

  return <>
    <Area style={{ display: data && data.length > 0 ? 'block' : 'none' }}  {...defalutConfig} />
    {
      !data || data.length < 1 ? <NoData /> : null
    }
  </>
};

